// Verrou de défilement GLOBAL des popups (plainte du propriétaire, 2026-10-08 :
// « la plupart des endroits où il y a une fenêtre popup, le scroll ne suit pas
// l'image, mais juste l'image en arrière-plan »).
//
// lib/scrollLock.js (lockScroll/unlockScroll — arrête Lenis + gèle body) existe
// déjà, mais il fallait l'appeler dans CHAQUE popup : seuls quelques-uns le
// faisaient (visionneuses, popup produit). Ce module comble les oublis SANS
// retoucher chaque popup : un observateur détecte l'ouverture/fermeture de toute
// fenêtre popup (recouvrement « fixed inset-0 » assombrissant — patron commun des
// popups maison : Admin, Ventes & Soumissions, signature, campagnes, rapports…)
// et appelle lockScroll()/unlockScroll() à sa place. Le verrou de scrollLock.js
// est COMPTÉ, donc les popups qui verrouillent déjà eux-mêmes (visionneuses) ne
// font qu'ajouter un verrou de plus — aucun conflit.
//
// Le panneau défilant du popup reçoit data-lenis-prevent pour que Lenis (arrêté)
// laisse sa molette défiler le CONTENU du popup normalement.
import { lockScroll, unlockScroll } from "./scrollLock";

const OVERLAY_SEL = [
  'div.fixed.inset-0[class*="backdrop-blur"]',     // popup mono-élément (visionneuses, popup produit)
  'div.fixed.inset-0:has(> [class*="backdrop-blur"])',  // popup deux éléments (popups admin maison)
  // Recouvrements shadcn/Radix (Dialog, Sheet, Drawer, AlertDialog) : fond
  // « bg-black/80 » SANS blur — longtemps oubliés du verrou (l'arrière-plan
  // défilait derrière la boîte de dialogue). Leur panneau porte data-lenis-prevent.
  'div.fixed.inset-0[class*="bg-black"]',
].join(", ");
const PANNEAU_SEL = '[class*="overflow-y-auto"], [class*="overflow-auto"]';

let ouverts = 0;

function appliquer() {
  const overlays = document.querySelectorAll(OVERLAY_SEL);
  // Le contenu du popup doit pouvoir défiler pendant que Lenis est arrêté
  overlays.forEach((ov) => {
    ov.querySelectorAll(PANNEAU_SEL).forEach((p) => {
      if (!p.hasAttribute("data-lenis-prevent")) p.setAttribute("data-lenis-prevent", "");
    });
  });
  const n = overlays.length;
  while (ouverts < n) { lockScroll(); ouverts += 1; }
  while (ouverts > n) { unlockScroll(); ouverts -= 1; }
}

// iOS : overflow:hidden ne suffit pas toujours au tactile — on bloque le geste
// hors du panneau du popup (le panneau, lui, défile via data-lenis-prevent).
function gardeTactile(e) {
  if (ouverts === 0) return;
  if (e.target && e.target.closest && e.target.closest(PANNEAU_SEL)) return;
  if (e.cancelable) e.preventDefault();
}

export function installerVerrouDefilementPopups() {
  if (typeof window === "undefined" || window.__mtVerrouPopups) return;
  window.__mtVerrouPopups = true;
  const obs = new MutationObserver(() => appliquer());
  obs.observe(document.body, { childList: true, subtree: true });
  window.addEventListener("touchmove", gardeTactile, { passive: false, capture: true });
  appliquer();
}
